import Vue from 'vue';
import App from '@/loginPage/App.vue';
import Store from '@/loginPage/store';
import {
  computePosition,
  offset,
  shift,
  flip
  // arrow
} from '@floating-ui/dom';

// BEGIN - COMMENT OUT BELOW WHEN PUSHING TO REMOTE, ONLY USE DURING LOCAL FE DEV WORK
// import {
// 	makeLoginServer
// } from "../api/loginPage";
// makeLoginServer()
// END - COMMENT OUT ABOVE WHEN PUSHING TO REMOTE, ONLY USE DURING LOCAL FE DEV WORK

Vue.config.devtools = true;
Vue.config.productionTip = false;

// Hack for floating ui
window.process = {
  env: {
    NODE_ENV: 'production'
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const loginPage = document.getElementById('loginPage')
	const input = loginPage.querySelector('input[type="hidden"]') || false;
	const tokenValue = input?.value || loginPage.getAttribute('data-token') || false;
  const loginButton = document.querySelector('.js-login-button')
  const cacheBust = new Date().getTime()
  const loginAnchor = document.querySelector('.header-profile')
  const loginPageWrapper = document.querySelector('.login-page-wrapper')
  const openLogin = document.querySelectorAll('.js-open-login')
  const openRegistration = document.querySelectorAll('.js-open-registration')
  const hash = window.location.hash
  let firstClick = false
  let mql = window.matchMedia('(min-width: 1200px)');
  let dir = 'left'
  const parseHash = (hashVal) => {
    loginButton.removeAttribute('disabled')
    if(hashVal === '#registration') {
      loginPage.setAttribute('data-registration', true)
    }
    if(hashVal === '#login' || hashVal === '#registration'){
      loginAnchor.click()
    } 
    history.replaceState(null, null, ' ')
  }
  // Future home of sessionStorage based authentication
  // if(!sessionStorage.getItem('isAuthenticated')) {
  // } else {
  //   loginPage.dataset.loggedIn = "true"
  // }
  fetch(`/api/account/isauthenticated?${cacheBust}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'text/plain'
    },
  })
  .then((response) => response.json())
  .then(data => {
    // for use in sessionStorage based auth
    // if(data.isAuthenticated) {
    //   loginPage.dataset.loggedIn = "true"
    //   sessionStorage.setItem('isAuthenticated', true)
    // } else {
    //   loginPage.dataset.loggedIn = "false"
    //   sessionStorage.setItem('isAuthenticated', false)
    // }
    // using strings here as that is how the BE originally set it up and if we need to swap back we dont want to update the entire app again
    data.isAuthenticated ? loginPage.dataset.loggedIn = "true" : loginPage.dataset.loggedIn = "false"
    parseHash(hash)
      // we can potentially use this down the road to show the login page on first load regardless of state
      // loginPage.setAttribute('data-login', true)
    
  })
  
  

  if (mql.matches) {
    dir = 'right'
  }
  loginAnchor.addEventListener('click', (e) => {
    e.preventDefault()
    if (!loginPageWrapper.classList.contains('is-active')) {
      document.body.classList.add('login-is-active')
      loginPageWrapper.classList.add('is-active')
      // Anchoring login
      computePosition(loginAnchor, loginPageWrapper, {
        placement: dir,
        middleware: [
          // offset({crossAxis:-25}),
          // offset(({rects}) => {
          //   return -rects.reference.width / 2 - rects.floating.width / 2;
          // })
          flip(),
          shift()
        ]
      }).then(({
        x,
        y,
        placement,
        // middlewareData
      }) => {
        Object.assign(loginPageWrapper.style, {
          left: `${x-x}px`,
          top: `${y}px`,
        });
        const staticSide = {
          top: 'bottom',
          right: 'left',
          bottom: 'top',
          left: 'right',
        } [placement.split('-')[0]];
      });
    } else {
      loginPageWrapper.classList.remove('is-active')
      document.body.classList.remove('login-is-active')
    }
    if (!firstClick) {
			const dataPlusToken = Object.assign({}, loginPage.dataset, {token: tokenValue});
      const app = new Vue({
        store: new Store().store,
        data: () =>  dataPlusToken,
        render: h => h(App),
      })
      app.$mount(loginPage)
      firstClick = true
    }
  })
  openLogin.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault()
      loginAnchor.click()
    })
  })
  openRegistration.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault()
      loginPage.setAttribute('data-registration', true)
      loginButton.removeAttribute('disabled')
      loginAnchor.click()
    })
  })
}, );